module.exports = "<svg width=\"7px\" height=\"5px\" viewBox=\"0 0 7 5\"><path d=\"M0,0h7L3.5,5L0,0z\"></path></svg>"